import React from "react";

export default function Graph_Intro() {
  return (
    <div>
      <h1>Graph_Intro</h1>
      <p>This is the Graph_Intro component.</p>
    </div>
  );
}
